/* El-Outlet · Winter '27 sections — behaviour
   Idempotent: safe to load once per section. Re-initialises on theme-editor events.
   No strings are built in JS (Weglot translates server-rendered text only). */
(function () {
  if (window.ELW) { window.ELW.init(document); return; }

  var cleanups = new WeakMap();
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function onCleanup(el, fn) {
    var list = cleanups.get(el) || [];
    list.push(fn);
    cleanups.set(el, list);
  }
  function destroy(root) {
    root.querySelectorAll('[data-elw-ready]').forEach(function (el) {
      (cleanups.get(el) || []).forEach(function (fn) { try { fn(); } catch (e) {} });
      cleanups.delete(el);
      el.removeAttribute('data-elw-ready');
    });
  }
  function once(el) {
    if (el.hasAttribute('data-elw-ready')) return false;
    el.setAttribute('data-elw-ready', '');
    return true;
  }
  function money(cents) {
    try {
      if (window.Shopify && typeof Shopify.formatMoney === 'function' && window.moneyFormat) {
        return Shopify.formatMoney(cents, window.moneyFormat);
      }
    } catch (e) {}
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EGP';
    return Math.round(cents / 100).toLocaleString('en-US') + ' ' + cur;
  }
  function moneyClean(cents) { return money(cents).replace(/\.00(?!\d)/, ''); }

  /* ---------- scroll reveal ---------- */
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  }, { threshold: 0.12 }) : null;

  function initReveal(root) {
    root.querySelectorAll('.elw-reveal').forEach(function (el) {
      if (!io || reduceMotion || (window.Shopify && Shopify.designMode)) { el.classList.add('is-in'); return; }
      io.observe(el);
    });
  }

  /* ---------- hero: audience switch + autoplay ---------- */
  function initHero(root) {
    root.querySelectorAll('[data-elw-hero]').forEach(function (hero) {
      if (!once(hero)) return;
      var tabs = [].slice.call(hero.querySelectorAll('[data-elw-tab]'));
      var imgs = [].slice.call(hero.querySelectorAll('.elw-hero__media > img, .elw-hero__media > .elw-hero__ph'));
      var panels = [].slice.call(hero.querySelectorAll('[data-elw-panel]')); // two groups (sub + CTA), matched by index value
      var n = Math.max(imgs.length, tabs.length);
      if (n < 2) return;
      var idx = 0, timer = null;
      var autoplay = hero.getAttribute('data-autoplay') === 'true' && !reduceMotion;
      var delay = (parseInt(hero.getAttribute('data-seconds'), 10) || 5) * 1000;

      function show(i) {
        idx = (i + n) % n;
        tabs.forEach(function (t, k) { t.setAttribute('aria-selected', k === idx ? 'true' : 'false'); });
        imgs.forEach(function (im, k) { im.classList.toggle('is-on', k === idx); });
        panels.forEach(function (p) { p.hidden = +p.getAttribute('data-elw-panel') !== idx; });
      }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function start() { stop(); if (autoplay && !document.hidden) timer = setInterval(function () { show(idx + 1); }, delay); }

      tabs.forEach(function (t, k) {
        t.addEventListener('click', function () { autoplay = false; stop(); show(k); });
      });
      function onVis() { document.hidden ? stop() : start(); }
      function onBlockSelect(e) {
        var p = e.target.closest && e.target.closest('[data-elw-panel]');
        if (p) { autoplay = false; stop(); show(+p.getAttribute('data-elw-panel')); }
      }
      document.addEventListener('visibilitychange', onVis);
      hero.addEventListener('shopify:block:select', onBlockSelect);
      onCleanup(hero, function () { stop(); document.removeEventListener('visibilitychange', onVis); });
      show(0); start();
    });
  }

  /* ---------- feels like: temperature -> outfit tier ---------- */
  function initFeels(root) {
    root.querySelectorAll('[data-elw-feels]').forEach(function (box) {
      if (!once(box)) return;
      var range = box.querySelector('[data-elw-range]');
      var deg = box.querySelector('[data-elw-deg]');
      var panels = [].slice.call(box.querySelectorAll('[data-elw-tier]'));
      if (!range || !panels.length) return;
      panels.sort(function (a, b) { return (+a.getAttribute('data-max')) - (+b.getAttribute('data-max')); });
      var lo = +range.min, hi = +range.max, active = null;

      function update() {
        var v = +range.value;
        deg.firstChild.nodeValue = v;
        var warm = Math.max(0, Math.min(1, (v - lo) / (hi - lo || 1)));
        box.style.setProperty('--elw-deg', 'color-mix(in srgb, #6B1D33 ' + Math.round(warm * 100) + '%, #5E7C99)');
        var next = panels.filter(function (p) { return v <= +p.getAttribute('data-max'); })[0] || panels[panels.length - 1];
        if (next !== active) {
          panels.forEach(function (p) { p.hidden = p !== next; });
          active = next;
        }
      }
      range.addEventListener('input', update);
      function onBlockSelect(e) {
        var p = e.target.closest('[data-elw-tier]');
        if (!p) return;
        range.value = Math.min(+range.max, Math.max(+range.min, +p.getAttribute('data-max')));
        update();
      }
      box.addEventListener('shopify:block:select', onBlockSelect);
      update();
    });
  }

  /* ---------- shop the look: pick pieces, free-shipping bar, add to cart ---------- */
  function initLook(root) {
    root.querySelectorAll('[data-elw-look]').forEach(function (box) {
      if (!once(box)) return;
      var threshold = (parseFloat(box.getAttribute('data-threshold')) || 0) * 100; // cents
      var items = [].slice.call(box.querySelectorAll('[data-elw-item]'));
      var totalEl = box.querySelector('[data-elw-total]');
      var bar = box.querySelector('[data-elw-bar]');
      var ship = box.querySelector('[data-elw-ship]');
      var msgs = {
        empty: box.querySelector('[data-elw-msg="empty"]'),
        progress: box.querySelector('[data-elw-msg="progress"]'),
        done: box.querySelector('[data-elw-msg="done"]'),
        error: box.querySelector('[data-elw-msg="error"]')
      };
      var amountEl = box.querySelector('[data-elw-amount]');
      var cta = box.querySelector('[data-elw-cta]');

      function variantOf(it) {
        var sel = it.querySelector('select');
        if (sel) { var o = sel.options[sel.selectedIndex]; return { id: +sel.value, price: +o.getAttribute('data-price') }; }
        return { id: +it.getAttribute('data-variant'), price: +it.getAttribute('data-price') };
      }
      function show(which) { Object.keys(msgs).forEach(function (k) { if (msgs[k]) msgs[k].hidden = k !== which; }); }
      function refresh() {
        var total = 0, count = 0;
        items.forEach(function (it) {
          if (it.classList.contains('is-sel')) { total += variantOf(it).price; count++; }
        });
        totalEl.textContent = moneyClean(total);
        bar.style.width = (threshold ? Math.min(100, total / threshold * 100) : 0) + '%';
        var ok = threshold && total >= threshold;
        ship.classList.toggle('is-ok', !!ok);
        if (count === 0) show('empty');
        else if (ok) show('done');
        else { if (amountEl) amountEl.textContent = moneyClean(threshold - total); show('progress'); }
        if (cta) { cta.disabled = count === 0; }
      }
      items.forEach(function (it) {
        var btn = it.querySelector('[data-elw-add]');
        if (!btn || it.classList.contains('is-out')) return;
        btn.addEventListener('click', function () {
          var on = !it.classList.contains('is-sel');
          it.classList.toggle('is-sel', on);
          btn.setAttribute('aria-pressed', on ? 'true' : 'false');
          refresh();
        });
        var sel = it.querySelector('select');
        if (sel) sel.addEventListener('change', refresh);
      });

      if (cta) cta.addEventListener('click', function () {
        var payload = [];
        items.forEach(function (it) { if (it.classList.contains('is-sel')) payload.push({ id: variantOf(it).id, quantity: 1 }); });
        if (!payload.length) return;
        cta.classList.add('is-busy');
        var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: payload })
        }).then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (c) { return c.json(); });
        }).then(function (cart) {
          cta.classList.remove('is-busy');
          // Yuva's cart drawer exposes a global buildCart(cart, showDrawer); fall back to the cart page.
          if (typeof window.buildCart === 'function' && window.cartDrawerEnable) { window.buildCart(cart, true); }
          else { window.location.href = root + 'cart'; }
        }).catch(function () {
          cta.classList.remove('is-busy');
          show('error');
        });
      });
      refresh();
    });
  }

  /* ---------- countdown ---------- */
  function initCountdown(root) {
    root.querySelectorAll('[data-elw-countdown]').forEach(function (box) {
      if (!once(box)) return;
      var end = Date.parse(box.getAttribute('data-end') || '');
      var hideAfter = box.getAttribute('data-hide-after') === 'true';
      var timerEl = box.querySelector('[data-elw-timer]');
      var endedEl = box.querySelector('[data-elw-ended]');
      if (isNaN(end)) { if (timerEl) timerEl.hidden = true; return; }
      var cells = {
        d: box.querySelector('[data-unit="d"]'), h: box.querySelector('[data-unit="h"]'),
        m: box.querySelector('[data-unit="m"]'), s: box.querySelector('[data-unit="s"]')
      };
      var t;
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function tick() {
        var left = Math.max(0, end - Date.now());
        if (left === 0) {
          if (timerEl) timerEl.hidden = true;
          if (endedEl) endedEl.hidden = false;
          if (hideAfter && !(window.Shopify && Shopify.designMode)) box.closest('.elw-cd').hidden = true;
          clearInterval(t);
          return;
        }
        var s = Math.floor(left / 1000);
        cells.d.textContent = pad(Math.floor(s / 86400));
        cells.h.textContent = pad(Math.floor(s % 86400 / 3600));
        cells.m.textContent = pad(Math.floor(s % 3600 / 60));
        cells.s.textContent = pad(s % 60);
      }
      tick(); t = setInterval(tick, 1000);
      onCleanup(box, function () { clearInterval(t); });
    });
  }

  function init(root) {
    root = root || document;
    initReveal(root); initHero(root); initFeels(root); initLook(root); initCountdown(root);
  }

  window.ELW = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { destroy(e.target); });
})();
